import React, { useState, useCallback, memo } from 'react'
import { useQuery } from '@apollo/react-hooks'
import { useTranslation } from 'react-i18next'
import InfiniteScroll from 'react-infinite-scroller'

import { FeedArticlesQuery } from 'store'
import { Card, Loading } from 'components'
import { IArticle } from 'models'

const FeedArticlesList: React.FunctionComponent<{}> = memo(() => {
	const { i18n } = useTranslation()
	const [deletedIds, setDeletedIds]: [string[], any] = useState([])
	const updateDeletedIds = useCallback(
		(id: string) => () => {
			setDeletedIds((deletedIds: string[]) => deletedIds.concat([id]))
		},
		[],
	)

	const { data, error, loading, fetchMore } = useQuery(FeedArticlesQuery, {
		fetchPolicy: 'network-only',
		variables: {
			language: i18n.language,
			userId: '',
			companySlug: '',
			teamId: '',
			first: 2,
			after: '',
		},
	})
	if (loading) {
		return (
			<div style={{ flexGrow: 1, display: 'flex' }}>
				<Loading size={48} />
			</div>
		)
	}
	if (error) {
		return <div>Error! {error.message}</div>
	}

	// TODO -> replace 'any' type
	const articles = data
		? data.feedArticles.edges.map((edge: any) => {
				return edge.node
		  })
		: []
	const hasNextPage = data ? data.feedArticles.pageInfo.hasNextPage : false

	// implement InfiniteScroll
	return !loading ? (
		<section
			style={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}
		>
			<InfiniteScroll
				pageStart={0}
				threshold={10}
				loadMore={() => {
					return fetchMore({
						variables: {
							after:
								data.feedArticles.edges[
									data.feedArticles.edges.length - 1
								].cursor,
						},
						updateQuery: (
							previousQueryResult: any,
							{
								fetchMoreResult: {
									feedArticles: { edges: newEdges, pageInfo },
								},
							},
						) => {
							return newEdges.length > 0
								? {
										feedArticles: {
											__typename:
												previousQueryResult.feedArticles
													.__typename,
											edges: [
												...previousQueryResult
													.feedArticles.edges,
												...newEdges,
											],
											pageInfo,
										},
								  }
								: previousQueryResult
						},
					})
				}}
				hasMore={hasNextPage}
				loader={
					<div
						style={{ flexGrow: 1, display: 'flex' }}
						key={'loading'}
					>
						<Loading size={48} />
					</div>
				}
				// useWindow={true}
			>
				{articles
					.filter(
						(item: IArticle) =>
							item &&
							item.id &&
							deletedIds.indexOf(item.id) === -1,
					)
					.map((article: IArticle) => (
						<Card
							article={article}
							key={article.id}
							refetch={updateDeletedIds(article.id)}
						/>
					))}
			</InfiniteScroll>
		</section>
	) : (
		<div style={{ flexGrow: 1, display: 'flex' }}>
			<Loading size={48} />
		</div>
	)
})

export default FeedArticlesList
